import debounce from 'lodash/debounce';
import { readyToClose } from './actions';
import { sendNativeEvent } from './externalApiBridge';
/**
 * Sends a specific event to the native counterpart of the External API. Only
 * the events that native code in these apps acts on go to native
 * (externalApiBridge.native.ts). Do not test `typeof window` here: React
 * Native sets `window`, and that test stopped every event from 2026-05-06.
 *
 * @param {Object} store - The redux store.
 * @param {string} name - The name of the event to send.
 * @param {Object} data - The details/specifics of the event to send determined
 * by/associated with the specified {@code name}.
 * @returns {void}
 */
export function sendEvent(store, name, data) {
    sendNativeEvent(name, data);
}
/**
 * Debounced sending of `readyToClose`.
 */
export const _sendReadyToClose = debounce(dispatch => {
    dispatch(readyToClose());
}, 2500, { leading: true });
/**
 * Returns a participant info object based on the passed participant object from redux.
 *
 * @param {Participant} participant - The participant object from the redux store.
 * @returns {Object} - The participant info object.
 */
export function participantToParticipantInfo(participant) {
    return {
        isLocal: participant.local,
        email: participant.email,
        name: participant.name,
        participantId: participant.id,
        displayName: participant.displayName,
        avatarUrl: participant.avatarURL,
        role: participant.role
    };
}
